import {Logger} from 'neo-common';

import {GameDefinitionBase} from '../GameDefinitionBase';
import {GameConfigurationBase} from '../GameConfigurationBase';
import {AppBase} from '../AppBase';
import {PaytableClientHostConsumerBase} from './PaytableClientHostConsumerBase';

const appTypeName = 'Paytable';

/**
 * Base paytable application construction
 */
export abstract class PaytableAppBase<TGameConfiguration extends GameConfigurationBase,
    TGameDefinition extends GameDefinitionBase,
    TClientHostConsumer extends PaytableClientHostConsumerBase>
    extends AppBase<TGameConfiguration, TGameDefinition, TClientHostConsumer> {

    constructor() {
        super();

        if (DEBUG) {
            Logger.debugGroup(this.loggerGroup,
                'start, user agent: ' + window.navigator.userAgent);
        }
    }

    protected get supportsRealityCheck(): boolean {
        return false;
    }

    protected startRealityCheck(): void {
        throw new Error('Not supported.');
    }

    protected get appTypeName(): string {
        return appTypeName;
    }

    protected prepareLoad(): Promise<boolean> {
        return Promise.resolve(true);
    }

    protected validateClientHost(): void {
        super.validateClientHost();

        if (!this._clientHost.supports.paytable) {
            if (DEBUG) {
                Logger.errorGroup(`${this.loggerGroup}`,
                    `Could not initialize paytable from client host '${this._clientHost.type}' which does not supports paytable!`);
            }

            throw new Error(`Error in loading paytable!`);
        }
    }

    public exit(): Promise<any> {
        throw new Error('Not supported.');
    }

    public history(): Promise<any> {
        throw new Error('Not supported.');
    }

    public continue(): Promise<any> {
        throw new Error('Not supported.');
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/GameEngine/Paytable/PaytableAppBase.ts
 **/